import { TAccount } from "@/api/v1_0";
import {
  MainMenuBlock,
  MobileHeader,
  Modal as ModalComponents,
} from "@/components";
import { Logged } from "@/routing";
import { useStore } from "@/store";
import { TTransactionsMap } from "@/types";
import { Features } from "@/types/features";
import { Modal } from "@/ui";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement, useCallback, useState } from "react";
import {
  Analytics,
  Debts,
  ExpenseCategories,
  Goals,
  IncomeSources,
  Pro,
  Savings,
} from "./_dependencies";

export const Dashboard: FunctionComponent = observer((): ReactElement => {
  const store = useStore();
  const [account, updateAccount] = useState<TAccount | null>(null);
  const [transactions, updateTransactions] = useState<
    TTransactionsMap | undefined
  >(undefined);

  const doAddAccount = useCallback((): void => {}, []);
  const doOpenAccount = useCallback(
    (account: TAccount) => updateAccount(account),
    []
  );
  const doCloseAccount = useCallback((): void => updateAccount(null), []);

  const doLoadTransactions = useCallback(async (): Promise<void> => {
    if (null === account) {
      return;
    }

    await store.wallet.loadAccount(account.uuid);
    updateTransactions(store.wallet.accountTransactions.get(account.uuid));
  }, [account]);

  return (
    <Logged>
      <MobileHeader />
      <MainMenuBlock />
      <div className="contentBlock">
        <div className="row">
          <div className="col-lg-8 col-md-8 leftSide marginBottom">
            <Analytics />
          </div>
          <div className="col-lg-4 col-md-4 rightSide">
            {!store.profile.pro &&
              store.profile.isFeatureEnabled([Features.Pro.Purchase]) && (
                <Pro onClick={store.popup.togglePro} />
              )}
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="blockLine">
              <h2>Операции</h2>
            </div>
          </div>
          <div className="col-lg-8 leftSide">
            <IncomeSources
              addAccount={doAddAccount}
              closeAccount={doCloseAccount}
              openAccount={doOpenAccount}
            />
            <Savings
              addAccount={doAddAccount}
              closeAccount={doCloseAccount}
              openAccount={doOpenAccount}
            />
            <ExpenseCategories
              addAccount={doAddAccount}
              closeAccount={doCloseAccount}
              openAccount={doOpenAccount}
            />
          </div>
          <div className="col-lg-4 rightSide">
            <Goals
              addAccount={doAddAccount}
              closeAccount={doCloseAccount}
              openAccount={doOpenAccount}
            />
            <Debts
              addAccount={doAddAccount}
              closeAccount={doCloseAccount}
              openAccount={doOpenAccount}
            />
          </div>
        </div>
      </div>
      {null !== account && (
        <>
          <Modal.Overlay onToggle={doCloseAccount} />
          <ModalComponents.Account
            account={account}
            transactions={transactions}
            onClose={doCloseAccount}
            onLoadTransactions={doLoadTransactions}
          />
        </>
      )}
    </Logged>
  );
});
